import wikimediaSrcSets from "../data/generated/wikimediaSrcSets.json";

interface SrcSetEntry {
  src1x: string;
  src2x: string;
}

const SRCSET_MAP = wikimediaSrcSets as Record<string, SrcSetEntry>;

/**
 * Real, verified 1x/2x srcSet for a Wikimedia-hosted image — see
 * scripts/fetch-wikimedia-srcsets.mjs for how src/data/generated/
 * wikimediaSrcSets.json is produced. Returns undefined (falls back to
 * plain `src`) for any URL not present in the generated lookup — a stale
 * or not-yet-run generator never breaks the image, it just means that one
 * photo doesn't get the responsive variant yet.
 */
export function getWikimediaSrcSet(url: string): string | undefined {
  const entry = SRCSET_MAP[url];
  if (!entry) return undefined;
  return `${entry.src1x} 1x, ${entry.src2x} 2x`;
}
